import {getStore} from '../redux/store'
import {toast as reduxToast} from './actions'

/**
 * Puts toast message into redux store.
 * @deprecated This function connects directly to redux, which is discouraged. Dispatch pure redux version from actions instead.
 */
export function toast(text) {
    getStore().dispatch(reduxToast(text))
}



// WEBPACK FOOTER //
// ./web/js/toasts/utils.js